var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import EditText from './Icons/EditText';
import { Input, Modal, Button, Checkbox } from '.';
const Edit = (props) => {
    const lang = useSelector((s) => s.lang);
    const [updating, setUpdating] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [value, setValue] = useState('');
    const [boolValue, setBoolValue] = useState(false);
    const toggleModal = () => setEditModalOpen(!editModalOpen);
    useEffect(() => {
        props.value && setValue(props.value);
    }, [props.value]);
    useEffect(() => {
        props.boolValue && setBoolValue(props.boolValue);
    }, [props.boolValue]);
    const update = () => __awaiter(void 0, void 0, void 0, function* () {
        setUpdating(true);
        try {
            if (props.isBool) {
                yield props.onUpdate(boolValue);
            }
            else {
                yield props.onUpdate(value);
            }
        }
        catch (err) {
            alert('Error');
            console.error(err);
        }
        setUpdating(false);
        setEditModalOpen(false);
    });
    return (React.createElement(Wrapper, null,
        React.createElement(StyledEditText, { onClick: toggleModal }),
        editModalOpen && (React.createElement(Modal, { onToggle: toggleModal, header: props.placeholder },
            props.isBool ? (React.createElement(Checkbox, { placeholder: props.placeholder, checked: boolValue, onChange: (e) => {
                    setBoolValue(e.target.checked);
                } })) : (React.createElement(Input, { placeholder: props.placeholder, value: value, onChange: (e) => {
                    setValue(e.target.value);
                } })),
            React.createElement("br", null),
            React.createElement(Button, { loading: updating, onClick: update, block: true }, lang.misc.save)))));
};
export default Edit;
const Wrapper = styled.div `
  padding-left: 8px;
  vertical-align: middle;
  display: inline-block;
`;
const StyledEditText = styled(EditText) `
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
//# sourceMappingURL=Edit.js.map